import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { CompanyKYCModalBase } from './ModalBase';
import { CardCompanyHeader } from '../../../Companies/components/CardCompanyHeader';
import { Loader } from '../../../../components/Loader';
import { CompanyKYCDocuments } from './ModalDocuments';
import { UserQuickCreator } from '../../../Users/pages/QuickCreate';
import { DoubleVATModal } from '../../../Companies/components/DoubleVATModal';
import {
  addUserToCompany,
  fetchCompany,
  initiateCompanyEdit,
  setNewCompanyValue,
  updateCompanyProperties,
} from '../../../Companies/actions';
import { toggleKanbanCompanyModal } from '../../actions';
import { createUser } from '../../../Users/actions';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { selectCompany, selectNewCompany } from '../../../Companies/selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import {
  COMPANY_QUICK_CREATE_FIELDS,
  INITIATE_COMPANY_EDIT,
  REQUEST_ADD_DOCUMENT,
  REQUEST_COMPANY,
  WIENTJES_COMPANY_KANBAN_FIELDS,
} from '../../../Companies/constants';
import { AppClientId } from '../../../Shared/constants';
import env from '../../../../env';
import { VAT_DUPLICATE_MESSAGE } from '../../../../utils/request';

const Container = styled.div`
  overflow-x: auto;
  position: fixed;
  top: 72px;
  right: 0;
  width: 100%;
  max-width: 610px;
  height: 100vh;
  padding: 36px 24px 100px 36px;
  background-color: #fff;

  box-shadow: -14px 0px 15px -11px rgba(66, 68, 90, 0.31);

  .box1 {
    border-bottom: 1px solid #ddd;
    margin-bottom: 16px;
    padding-bottom: 16px;

    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
  }
`;

const STATE = {
  addresses: [],
  stepperClickStep: null,
  stepperClick: false,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyKYCActionsCardComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCompany(result => {
      if (result?.id) {
        this.props.init();
      }
    });

    this.checkFields();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.values !== prevProps.values) {
      this.checkFields();
    }
  }

  get fields() {
    const reqFields = this.props.requiredFields ?? [];
    let fields = [
      ...COMPANY_QUICK_CREATE_FIELDS.slice(0, COMPANY_QUICK_CREATE_FIELDS.length - 2),
      'BTW_number',
      ...reqFields,
      ...COMPANY_QUICK_CREATE_FIELDS.slice(COMPANY_QUICK_CREATE_FIELDS.length - 2),
      'relation_financial_contact_id',
    ];

    return fields;
  }

  get wientjesFields() {
    let aditional = this.props.aditionalFields ?? [];
    let newFields = this.props.newFields ?? [];
    let fields = [...WIENTJES_COMPANY_KANBAN_FIELDS, ...aditional];

    return fields;
  }

  get checkDocuments() {
    let result = [];
    this.props.requiredDocuments?.map(requiredDoc => {
      const document = this.props.company?.documents?.find(doc => doc?.originalFilename == requiredDoc);
      return document && result.push(document);
    });

    return result?.length == this.props.requiredDocuments?.length;
  }

  get resetValuesArray() {
    return [
      ...this.getInstallationFields(),
      'relation_financial_contact_id',
      'relation_commercial_contact_id',
      'relation_vehicle_documents_contact_id',
    ];
  }

  get isAccAction() {
    return this.props.action?.functionName.substr(0, 3) === 'acc';
  }

  get isNlCustomer() {
    return ['acc_nl_in', 'acc_nl_out', 'req_fields_nl_in', 'req_fields_nl_out'].includes(this.props.action?.functionName);
  }

  get isEUCustomer() {
    return [
      'req_fields_EU_in',
      'req_fields_EU_out',
      'acc_EU_in',
      'acc_EU_out',
      'req_fields_non_EU_in',
      'req_fields_non_EU_out',
      'acc_non_eu_in',
      'acc_non_eu_out',
    ].includes(this.props.action?.functionName);
  }

  getInstallationFields() {
    let fields = this.fields;

    if (env.clientId == AppClientId.AUTOWIENTJES) {
      fields = this.wientjesFields;
    }

    return fields;
  }

  toggleUserModal() {
    this.setState({ showUserModal: true });
  }

  createUser(callback) {
    let userDto = {};
    if (this.props.values?.company_type == 'individual') {
      userDto = {
        email_address: this.props.values?.email || '',
        password: '',
        properties: [
          { name: 'name', value: this.props.values?.name || '' },
          { name: 'surname', value: this.props.values?.surname || '' },
        ],
      };

      this.props.createUser(userDto, result => {
        if (result?.id) {
          this.props.setValue(result?.id, 'relation_financial_contact_id');
          return callback();
        }
      });
    }
  }

  checkFields() {
    let fields = [...(this.props.requiredFields ?? []), 'accountManagerId'];
    if (this.props.values?.company_type == 'company') {
      fields.push('relation_financial_contact_id');
    }
    let result = [];

    fields.map(field => {
      if (!this.props.values[field]) {
        return result.push(field);
      }
    });

    this.setState({ requiredFields: result });
  }

  save(options) {
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };
    const requestBodyTypes = { addressLine1: '', postcode: '', city: '', countryId: '', accountManagerId: '' };
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    const homeAddressId = this.props.values?.addresses?.filter(a => a.typeId === addressTypeId)[0]?.id;
    let newAddress = {};

    if (homeAddressId) {
      newAddress['id'] = homeAddressId;
    }

    let isRoleselected =
      this.props.values?.relation_financial_contact_id ||
      this.props.values?.relation_commercial_contact_id ||
      this.props.values?.relation_vehicle_documents_contact_id;

    let prop = {
      properties: [{ name: 'status', value: this.props.values?.status }],
      addresses: [],
      accountManagerId: this.props.values.accountManagerId || null,
    };

    Object.keys(this.props.values).forEach(key => {
      if (
        key === 'relation_financial_contact_id' &&
        this.props.values[key] &&
        (this.props.values?.company_type === 'individual' ||
          (this.props.values?.company_type === 'company' && !isRoleselected))
      ) {
        prop.properties.push({
          name: 'relation_financial_contact_id',
          value: this.props.values[key],
        });
        return;
      }

      if (key === 'BTW_number' && this.props.values[key]) {
        prop.properties.push({
          name: 'BTW_number',
          value: this.props.values?.BTW_number?.replace(/\s/g, '')?.toUpperCase(),
        });
        return;
      }

      if (this.props.values[key] !== '' && key !== 'addresses' && !Object.keys(requestBodyTypes).includes(key)) {
        this.props.values[key] &&
          prop.properties.push({
            name: key,
            value: this.props.values[key],
          });
      }
    });

    for (let i in addressProps) {
      if (this.props.values[i] != '') {
        newAddress[i] = this.props.values[i];
        newAddress['typeId'] = addressTypeId;
      }
    }

    let addresses = [];
    try {
      Object.keys(newAddress).length > 1
        ? (addresses = [...this.props.values?.addresses, newAddress])
        : (addresses = [...this.props.values?.addresses]);
    } catch (e) {}
    this.props.patch(
      prop.properties,
      addresses,
      prop.accountManagerId,
      result => {
        if (result?.data?.message?.toLowerCase() === VAT_DUPLICATE_MESSAGE?.toLowerCase()) {
          this.setState({
            showDoubleVATModal: true,
            matchedCompaniesIds: result?.data?.matchedCompaniesIds,
          });
        }
        if (result?.id) {
          if (this.props.values?.relation_financial_contact_id) {
            const newUser = result?.users?.find(u => u?.id == this.props.values?.relation_financial_contact_id);
            !newUser?.id &&
              this.props.addUserToCompany(result?.id, this.props.values?.relation_financial_contact_id, res => {});
          }
          this.props.resetValues(this.resetValuesArray);
          this.props.resetModal();

          return;
        }
      },
      true,
    );
  }

  onCancelDoubleVATModal() {
    this.setState({
      showDoubleVATModal: false,
      matchedCompaniesIds: [],
    });
  }

  reset() {
    this.props.resetValues(resetValuesArray);
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container innerWidth={window.innerWidth}>
        {this.state.showDoubleVATModal && this.state.matchedCompaniesIds?.[0] && (
          <DoubleVATModal
            onSave={() => this.save({ skipVatUniquenessCheck: true })}
            onCancel={this.onCancelDoubleVATModal.bind(this)}
            existsCompanyId={this.state.matchedCompaniesIds[0]}
          />
        )}
        <HBox vCenter className="box1">
          <h2>
            {this.lbl('kanban.company_boards.modal.required_fields')} {this.props.action?.functionName}
          </h2>
          <Button small primary onClick={this.save.bind(this)}>
            {this.lbl('ready')}
          </Button>
        </HBox>

        <CardCompanyHeader
          KYC_modal
          isNlCustomer={this.isNlCustomer}
          isEUCustomer={this.isEUCustomer}
          editableStatus={this.props.editableStatus}
          company={this.props.company}
          isAccAction={this.isAccAction}
        />
        <VBox className="box1">
          <h2 style={{ marginBottom: '20px' }}>{this.lbl('kanban.company_boards.modal.relation_data')}</h2>
          {this.props.work ? (
            <Loader small />
          ) : (
            <CompanyKYCModalBase
              requiredFields={this.state.requiredFields ?? []}
              newFields={this.props.newFields}
              onShowUserModal={this.toggleUserModal.bind(this)}
              board_id={this.props.board_id}
              column={this.props.column}
              documents={['location']}
              fields={this.getInstallationFields()}
              company={this.props.company}
              KYC_modal
              isNlCustomer={this.isNlCustomer}
              isEUCustomer={this.isEUCustomer}
              onSave={
                this.props.values?.company_type == 'individual'
                  ? () => this.createUser(this.save.bind(this))
                  : this.save.bind(this)
              }
            />
          )}
        </VBox>

        <VBox className="box1">
          {this.props.work || this.props.workDocs ? (
            <Loader small />
          ) : (
            <CompanyKYCDocuments
              board_id={this.props.board_id}
              column={this.props.column}
              documents={this.props.requiredDocuments}
              company={this.props.company}
            />
          )}
        </VBox>
        {this.state.showUserModal && <UserQuickCreator kanban reset={() => this.setState({ showUserModal: false })} />}
      </Container>
    );
  }
}

CompanyKYCActionsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY, `${REQUEST_COMPANY}-${ownProps.company?.id}`, INITIATE_COMPANY_EDIT]),
    workDocs: selectWork(REQUEST_ADD_DOCUMENT),
    values: selectNewCompany(),
    addressTypes: selectAddressTypes(),
    company: selectCompany(ownProps.company?.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateCompanyEdit(ownProps.company?.id));
    },
    fetchCompany(callback) {
      dispatch(fetchCompany(ownProps.company?.id, callback));
    },
    patch(props, addresses, accountManagerId, callback, skipVatUniquenessCheck) {
      dispatch(
        updateCompanyProperties(ownProps.company?.id, props, addresses, accountManagerId, callback, skipVatUniquenessCheck),
      );
    },
    createUser(userDto, callback) {
      dispatch(createUser(userDto, callback));
    },

    setValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },

    addUserToCompany(companyId, userId, callback) {
      dispatch(addUserToCompany(companyId, userId, callback));
    },
    resetValues(values) {
      values.map(type => dispatch(setNewCompanyValue(type, '')));
    },
    resetModal() {
      dispatch(toggleKanbanCompanyModal());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyKYCActionsCard = compose(withConnect, withRouter)(CompanyKYCActionsCardComp);
